import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

import Box from "../components/Box";
import PropertyLabel from "../components/PropertyLabel";
import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import HeaderPreview from "../components/HeaderPreview";
import DesktopPreview from "../components/DesktopPreview";
import SmartphonePreview from "../components/SmartphonePreview";

import { fetchQR } from "../actions/qrs";

class QRDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isQRCodeLoaded: false,
    };
    this.handleQRCodeLoad = this.handleQRCodeLoad.bind(this);
    this.downloadQRCode = this.downloadQRCode.bind(this);
  }

  componentDidMount() {
    this.props.fetchQR(this.props.match.params.id);
  }

  handleQRCodeLoad(e) {
    this.setState({
      isQRCodeLoaded: true,
    });
  }

  downloadQRCode(e) {
    const svgData = document.getElementById("qrimage");
    const svgBlob = new Blob([svgData.outerHTML], {
      type: "image/svg+xml;charset=utf-8",
    });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = "qrcode.svg";
    downloadLink.click();
    URL.revokeObjectURL(svgUrl);
  }

  returnQrType(type) {
    switch (type) {
      case "pay":
        return "Pago";
      case "free":
        return "Gratis";
      case "test":
        return "Test";
    }
  }

  returnQrMode(mode) {
    switch (mode) {
      case 0:
        return "MTO DIARIO";
      case 1:
        return "OTO DIARIO SIN PIN";
      case 2:
        return "BAQUEIRA";
      case 3:
        return "OTO DIARIO CON PIN";
    }
  }

  /*downloadQRCode(e) {

    const { qr } = this.props


    const canvas = document.getElementById("qrimage");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qrimage.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }*/

  render() {
    const { role, type, qr, error, loading } = this.props;
    const { isQRCodeLoaded } = this.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!qr || loading) {
      return <LoadingProgress />
    }

    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-8 col-md-8">
            <h1>
              <span className="text-vw-light">QR </span>
              <span className="text-vw-dark">{qr.Code}</span>
            </h1>
          </div>
          {role === "ADMIN" && type === "MASTER" && (
            <div className="col-xs-12 col-sm-4 col-md-4 text-right">
              <Link to={`/qrs/${qr._id}/edit`}>
                <button className="btn bg-vw-light text-white mr-1">
                  <i className="fas fa-edit mr-1"></i>Editar
                </button>
              </Link>
            </div>
          )}
        </div>
        <hr className="bg-vw-light" />
        <div className="row mb-2">
          <div className="col">
            <Box title="Resumen" icon="sliders-h">
              <div className="row">
                <div className="col col-12 col-xs-12 col-md-4">
                  <PropertyLabel name="Código" value={qr.Code} />
                  <PropertyLabel name="Cliente" value={qr.Customer.Fullname} />
                  <PropertyLabel name="Zona" value={qr.Zone} />
                  <PropertyLabel
                    name="Tipo"
                    value={this.returnQrType(qr.Type)}
                  />
                  <PropertyLabel
                    name="Modo"
                    value={this.returnQrMode(qr.Mode)}
                  />
                  <PropertyLabel name="URL" value={qr.Url} />
                </div>
                <div
                  className="d-flex flex-column align-items-center col col-12 col-xs-12 col-md-4"
                  style={{ textAlign: "center" }}
                >
                  <QRCode
                    value={qr.Url}
                    id="qrimage"
                    renderAs="canvas"
                    size={256}
                    level={"H"}
                    includeMargin={true}
                    onLoad={(e) => this.handleQRCodeLoad(e)}
                  />
                  {isQRCodeLoaded && (
                    <button
                      className="mt-4 btn bg-vw-dark text-white mr-1"
                      onClick={(e) => this.downloadQRCode(e)}
                    >
                      <i className="fas fa-download mr-1"></i>Descargar QR
                    </button>
                  )}
                  <button
                    className="mt-4 btn bg-vw-dark text-white mr-1"
                    onClick={(e) => this.downloadQRCode(e)}
                  >
                    <i className="fas fa-download mr-1"></i>Descargar QR
                  </button>
                </div>
                <div className="col col-12 col-xs-12 col-md-4">
                  {qr.headerConfig && (
                    <>
                      {qr.headerConfig.logoBase64 && (
                        <div className="mt-2">
                          <strong>Logo:</strong>
                          <div
                            className="text-center p-2 w-50"
                            style={{
                              backgroundColor: qr.headerConfig.primaryColor,
                              borderRadius: "4px",
                            }}
                          >
                            <img
                              src={qr.headerConfig.logoBase64}
                              alt="Logo Actual"
                              style={{ maxHeight: "50px", maxWidth: "100%" }}
                            />
                          </div>
                        </div>
                      )}
                      {(qr.headerConfig.primaryColor || qr.headerConfig.secondaryColor) && (
                        <PropertyLabel
                          name="Gradiente Header"
                          value={
                            <span>
                              {qr.headerConfig.primaryColor && (
                                <>
                                  {qr.headerConfig.primaryColor}{" "}
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "20px",
                                      height: "20px",
                                      backgroundColor: qr.headerConfig.primaryColor,
                                      border: "1px solid #ccc",
                                      verticalAlign: "middle",
                                      marginRight: "8px",
                                    }}
                                  />
                                </>
                              )}
                              {qr.headerConfig.secondaryColor && (
                                <>
                                  {qr.headerConfig.secondaryColor}{" "}
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "20px",
                                      height: "20px",
                                      backgroundColor: qr.headerConfig.secondaryColor,
                                      border: "1px solid #ccc",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </>
                              )}
                            </span>
                          }
                        />
                      )}
                      {qr.headerConfig.backgroundColor && (
                        <PropertyLabel
                          name="Color de Fondo"
                          value={
                            <span>
                              {qr.headerConfig.backgroundColor}{" "}
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "20px",
                                  height: "20px",
                                  backgroundColor:
                                    qr.headerConfig.backgroundColor,
                                  border: "1px solid #ccc",
                                  verticalAlign: "middle",
                                }}
                              />
                            </span>
                          }
                        />
                      )}
                      {qr.headerConfig.textPrimary && (
                        <PropertyLabel
                          name="Texto Primario"
                          value={
                            <span>
                              {qr.headerConfig.textPrimary}{" "}
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "20px",
                                  height: "20px",
                                  backgroundColor: qr.headerConfig.textPrimary,
                                  border: "1px solid #ccc",
                                  verticalAlign: "middle",
                                }}
                              />
                            </span>
                          }
                        />
                      )}
                      {qr.headerConfig.textSecondary && (
                        <PropertyLabel
                          name="Texto Secundario"
                          value={
                            <span>
                              {qr.headerConfig.textSecondary}{" "}
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "20px",
                                  height: "20px",
                                  backgroundColor:
                                    qr.headerConfig.textSecondary,
                                  border: "1px solid #ccc",
                                  verticalAlign: "middle",
                                }}
                              />
                            </span>
                          }
                        />
                      )}
                      {qr.headerConfig.backgroundImage && (
                        <PropertyLabel
                          name="Imagen Fondo Desktop"
                          ml
                          value={
                            <a
                              href={qr.headerConfig.backgroundImage}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ wordBreak: "break-all" }}
                            >
                              {qr.headerConfig.backgroundImage}
                            </a>
                          }
                        />
                      )}
                      {qr.headerConfig.backgroundSmartphoneImage && (
                        <PropertyLabel
                          name="Imagen Fondo Smartphone"
                          ml
                          value={
                            <a
                              href={qr.headerConfig.backgroundSmartphoneImage}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ wordBreak: "break-all" }}
                            >
                              {qr.headerConfig.backgroundSmartphoneImage}
                            </a>
                          }
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Box>
          </div>
        </div>
        {qr.headerConfig && (
          <>
            {/* <div className="row mb-2">
              <div className="col">
                <Box title="Vista Previa del Header" icon="eye">
                  <HeaderPreview
                    primaryColor={qr.headerConfig.primaryColor}
                    secondaryColor={qr.headerConfig.secondaryColor}
                    backgroundColor={qr.headerConfig.backgroundColor}
                    textPrimary={qr.headerConfig.textPrimary}
                    textSecondary={qr.headerConfig.textSecondary}
                    logoBase64={qr.headerConfig.logoBase64}
                  />
                </Box>
              </div>
            </div> */}
            <div className="row mb-2">
              <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                <Box title="Vista Previa Desktop" icon="desktop">
                  <DesktopPreview
                    primaryColor={qr.headerConfig.primaryColor}
                    secondaryColor={qr.headerConfig.secondaryColor}
                    backgroundColor={qr.headerConfig.backgroundColor}
                    textPrimary={qr.headerConfig.textPrimary}
                    textSecondary={qr.headerConfig.textSecondary}
                    logoBase64={qr.headerConfig.logoBase64}
                    backgroundImage={qr.headerConfig.backgroundImage}
                  />
                </Box>
              </div>
              <div className="col-12 col-lg-6">
                <Box title="Vista Previa Smartphone" icon="mobile">
                  <SmartphonePreview
                    primaryColor={qr.headerConfig.primaryColor}
                    secondaryColor={qr.headerConfig.secondaryColor}
                    backgroundColor={qr.headerConfig.backgroundColor}
                    textPrimary={qr.headerConfig.textPrimary}
                    textSecondary={qr.headerConfig.textSecondary}
                    logoBase64={qr.headerConfig.logoBase64}
                    backgroundSmartphoneImage={qr.headerConfig.backgroundSmartphoneImage}
                    backgroundImage={qr.headerConfig.backgroundImage}
                  />
                </Box>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  qr: state.qrs.qr,
  loading: state.qrs.loading,
  error: state.qrs.error,
  role: state.auth.role,
  type: state.auth.type,
});

const mapDispatchToProps = (dispatch) => ({
  fetchQR: bindActionCreators(fetchQR, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QRDetailsView);
